const initialState = {
  lr: null,
  isOpen: false
};

export const clientEboxViewerReducer = (state = initialState, action) => {
  switch (action.type) {
    case "CLOSE_CLIENT_EBOX_VIEWER": {
      return initialState;
    }
    case "OPEN_CLIENT_EBOX_VIEWER": {
      return { ...state, ...action.viewer };
    }
    case "SET_CURRENT_CLIENT_EBOX_VIEWER": {
      return { ...state, currentMail: action.media };
    }
    case "FETCH_SINGLE_CLIENT_EBOX_FULFILLED": {
      const { data } = action.payload;
      return {
        ...state,
        currentMail: { ...data }
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/client-ebox-viewer.js